import * as React from 'react';
import {FunctionComponent} from 'react';
import {
    EventType,
    generateDataFieldText,
    generateEventTitleName,
    generateMainVisualisationText,
    generateTargetTypeText,
    PartEvent,
} from '../../../../models/PartEvent';
import {Anchor, AnchorOffsetType, AnchorPoint} from '../../../../models/Anchor';

interface OwnProps {
    event: PartEvent;
}

function generateAnchorText(anchor: Anchor): string {
    switch (anchor.offset_type) {
        case AnchorOffsetType.TimeSeconds:
            switch (anchor.anchor_point) {
                case AnchorPoint.Start:
                    return `at ${anchor.offset_value} seconds from the start of this part`;
                case AnchorPoint.End:
                    return `at ${anchor.offset_value} seconds before the end of this part`;
            }
    }
}

export const Title: FunctionComponent<OwnProps> = ({event}) => {
    switch (event.type) {
        case EventType.DataField0:
        case EventType.DataField1:
        case EventType.DataField2:
        case EventType.DataField3:
            return (
                <div className="event__title">
                    Change <span className="event__title--highlight">{generateEventTitleName(event.type)}</span> to{' '}
                    <span className="event__title--highlight">{generateDataFieldText(event.key)}</span>{' '}
                    {generateAnchorText(event.anchor)}
                </div>
            );
        case EventType.Target:
            return (
                <div className="event__title">
                    Set <span className="event__title--highlight">{generateEventTitleName(event.type)}</span> to{' '}
                    <span className="event__title--highlight">{generateTargetTypeText(event.key, event.value)}</span>{' '}
                    {generateAnchorText(event.anchor)}
                </div>
            );
        case EventType.Instruction:
            return (
                <div className="event__title">
                    Show <span className="event__title--highlight">{generateEventTitleName(event.type)}</span>{' '}
                    {event.value} {generateAnchorText(event.anchor)}
                </div>
            );
        case EventType.MainVisualisation:
            return (
                <div className="event__title">
                    Show <span className="event__title--highlight">{generateEventTitleName(event.type)}</span>{' '}
                    {generateMainVisualisationText(event.key)} {generateAnchorText(event.anchor)}
                </div>
            );
    }
};
